import { createOpenAPIClient } from "@marcuslongmuir/openapi-typescript-helpers";
import { userServiceSchema } from "@teamtable/api";

export const apiClient = createOpenAPIClient(userServiceSchema, {
  baseUrl: window.serverConfig?.API_URL || window.location.origin,
  fetchOverride: (request: Request) => {
    return fetch(request, { credentials: "include" });
  },
});
